export type FileKind = 'pdf' | 'image' | 'video' | 'file';

export const getFilePresentation = (label: string, contentType: string) => {
  const lowerLabel = label.toLowerCase();
  const isPdf = contentType.includes('pdf') || lowerLabel.endsWith('.pdf');
  const isImage =
    contentType.startsWith('image/') ||
    ['.jpg', '.jpeg', '.png', '.gif', '.webp'].some((ext) =>
      lowerLabel.endsWith(ext)
    );
  const isVideo =
    contentType.startsWith('video/') ||
    ['.mp4', '.mov', '.webm'].some((ext) => lowerLabel.endsWith(ext));

  const kind: FileKind = isPdf
    ? 'pdf'
    : isImage
      ? 'image'
      : isVideo
        ? 'video'
        : 'file';
  const fileTypeLabel =
    kind === 'pdf'
      ? 'PDF'
      : kind === 'image'
        ? 'Image'
        : kind === 'video'
          ? 'Video'
          : 'File';

  return { kind, fileTypeLabel };
};
